import React from "react";
import ReactAdminCustomRoute from "./ReactAdminCustomRoute";
import LoginCallback from "../auth/LoginCallback";
import { AuthManager } from "../auth/Auth";
import LogOut from "../auth/LogOut";
import LoggedOut from "../auth/LoggedOut";
import FrontChannelLogout from "../auth/FrontChannelLogout";
import { Redirect, Route } from "react-router-dom";
import resourceNames from "../data/resourceNames";
import { DriverLogsList } from "../../components/hos/logs/driver-logs/DriverLogsList";
import {
  WithPermissions,
  ResourceContextProvider,
  usePermissions,
} from "react-admin";
import { DriverLogView } from "../../components/hos/logs/driver-logs/DriverLogView";
import { LocationsHistoryView } from "../../components/locations/locations-history/LocationsHistoryView";
import { LocationLiveTrack } from "../../components/locations/locations-livetrack/LocationLiveTrack";
import { VehicleMaintenanceList } from "../../components/assets/maintenance/vehicle-maintenance/VehicleMaintenanceList";
import { VehicleMaintenanceCreate } from "../../components/assets/maintenance/vehicle-maintenance/VehicleMaintenanceCreate";
import { VehicleMaintenanceEdit } from "../../components/assets/maintenance/vehicle-maintenance/VehicleMaintenanceEdit";
import { Reports } from "../../components/reports/Reports";
//import { IftaMileageReport } from "../../components/reports/ifta-mileage/IftaMileageReport";
import { VehicleMileageReport } from "../../components/reports/vehicle-mileage/VehicleMileageReport";
import { VehicleDistanceReport } from "../../components/reports/vehicle-distance/VehicleDistanceReport";
import { LocationsHistoryReport } from "../../components/reports/locations-history/LocationsHistoryReport";
import { VehicleInactivityReport } from "../../components/reports/vehicle-inactivity/VehicleInactivityReport";
import { EldEventsReport } from "../../components/reports/eld-events/EldEventsReport";
import { VehicleDvirHistoryList } from "../../components/assets/dvir/vehicle-dvir/VehicleDvirHistoryList";
import { VehicleDvirView } from "../../components/assets/dvir/vehicle-dvir/VehicleDvirView";
//import { IftaSummaryReport } from "../../components/reports/ifta-summary/IftaSummaryReport";
import { VehicleMileageSummaryReport } from "../../components/reports/vehicle-mileage-summary/VehicleMileageSummaryReport";
import { VehicleMaintenanceDashboard } from "../../components/assets/maintenance-dashboard/VehicleMaintenanceDashboard";
import { EldMessagesList } from "../../components/master/elds/EldMessagesList";
import { EldMultipleCreate } from "../../components/master/elds/EldMultipleCreate";
import { DriverSafetyDashboard } from "../../components/safety/safety-dashboard/DriverSafetyDashboard";
import { DailyLogsReport } from "../../components/reports/daily-logs/DailyLogsReport";
import { DvirHistoryReport } from "../../components/reports/dvir-history/DvirHistoryReport";
import { StateTripsSingle } from "../../components/locations/ifta/StateTripsSingle";
import { TripReportDetail } from "../../components/reports/trip-report-detail/TripReportDetail";
import { TripDetail } from "../../components/reports/trip-detail/TripDetail";
import { IftaMileageReportBasic } from "../../components/reports/ifta-mileage-basic/IftaMileageReportBasic";
import { TenantEldUsageByEvents } from "../../components/master/tenant-registrations/TenantEldUsageByEvents";
import { TenantEldUsageByEventsByDays } from "../../components/master/tenant-registrations/TenantEldUsageByEventsByDays";
import { SafetyReport } from "../../components/reports/safety/SafetyReport";
import { FuelEconomyReport } from "../../components/reports/fuel-economy-report/FuelEconomyReport";
import { HarshDrivingReport } from "../../components/reports/harsh-driving-report/HarshDrivingReport";
import { IdleReports } from "../../components/reports/idle-reports/IdleReports";
import ViewRedirectApiClient from "../../components/administration/api-clients/ViewRedirectApiClient";
import DataImportExport from "../../components/administration/data-import-export/DataImportExport";
import DataTransferCategoryPage from "../../components/administration/data-import-export/DataTransferCategoryPage";
import permissionNames from "../auth/access-control/permissionNames";
import { ProLogsPermissions } from "../auth/permissions";

export const listOnlyComponentProps = {
  hasList: true,
  hasCreate: false,
  hasEdit: false,
  hasShow: false,
  options: {},
};

const RequireActionPermission = ({
  permission,
  children,
}: {
  permission: string;
  children: React.ReactElement;
}) => {
  const { permissions, loading } = usePermissions<ProLogsPermissions>();

  if (loading) {
    return null;
  }

  if (!permissions?.actionPermissions?.[permission]) {
    return <Redirect to="/" />;
  }

  return children;
};

export const getCustomRoutes = (authProvider: AuthManager) => {
  return [
    // <ReactAdminCustomRoute
    //   path="/callback"
    //   noLayout
    //   render={(props) => (
    //     <LoginCallback authProvider={authProvider} {...props} />
    //   )}
    // />,
    <ReactAdminCustomRoute
      noLayout
      path="/silent-callback"
      render={(props) => (
        <LoginCallback authProvider={authProvider} {...props} />
      )}
    />,
    <ReactAdminCustomRoute
      noLayout
      path="/logout"
      render={(props) => <LogOut authProvider={authProvider} {...props} />}
    />,
    <ReactAdminCustomRoute
      noLayout
      exact
      path="/logged-out"
      component={LoggedOut}
    />,
    <ReactAdminCustomRoute
      noLayout
      exact
      path="/front-channel-logout"
      component={FrontChannelLogout}
    />,
    // <Route exact path="/reports/ifta-mileage" component={IftaMileageReport} />,
    // <Route exact path="/reports/ifta-summary" component={IftaSummaryReport} />,
    <Route
      exact
      path="/reports/ifta-mileage-detail"
      component={VehicleMileageReport}
    />,
    <Route
      exact
      path="/reports/ifta-summary"
      component={VehicleMileageSummaryReport}
    />,
    <Route
      exact
      path="/reports/vehicle-distance"
      component={VehicleDistanceReport}
    />,
    <Route exact path="/reports/fuel-economy" component={FuelEconomyReport} />,
    <Route
      exact
      path="/reports/harsh-driving"
      component={HarshDrivingReport}
    />,
    <Route exact path="/reports/idle-reports" component={IdleReports} />,
    <Route
      exact
      path="/reports/locations-history"
      component={LocationsHistoryReport}
    />,
    <Route
      exact
      path="/reports/vehicle-inactivity"
      component={VehicleInactivityReport}
    />,
    <Route exact path="/reports/eld-events" component={EldEventsReport} />,
    <Route exact path="/reports/daily-logs" component={DailyLogsReport} />,
    <Route exact path="/reports/safety-report" component={SafetyReport} />,
    <Route
      exact
      path={`/${resourceNames.MASTER_TENANT_REGISTRATIONS}/:id/eld-usage-by-events`}
      render={(routeProps) => {
        const basePath = `/${resourceNames.MASTER_TENANT_REGISTRATIONS}`;
        const id = routeProps.match?.params?.id;

        return (
          <RequireActionPermission
            permission={
              permissionNames.admin.tenantRegistrations.viewEldDeviceUsage
            }
          >
            <ResourceContextProvider
              value={resourceNames.MASTER_TENANT_REGISTRATIONS}
            >
              <WithPermissions
                component={TenantEldUsageByEvents}
                basePath={basePath}
                resource={resourceNames.MASTER_TENANT_REGISTRATIONS}
                id={id}
                {...routeProps}
                {...listOnlyComponentProps}
                hasShow
              />
            </ResourceContextProvider>
          </RequireActionPermission>
        );
      }}
    />,
    <Route
      exact
      path={`/${resourceNames.MASTER_TENANT_REGISTRATIONS}/:id/eld-usage-by-events-by-days/:vehicleId/:serialNumber`}
      render={(routeProps) => {
        const id = routeProps.match?.params?.id;
        const basePath = `/${resourceNames.MASTER_TENANT_REGISTRATIONS}/${id}/eld-usage-by-events`;

        return (
          <RequireActionPermission
            permission={
              permissionNames.admin.tenantRegistrations.viewEldDeviceUsage
            }
          >
            <ResourceContextProvider
              value={resourceNames.MASTER_TENANT_REGISTRATIONS}
            >
              <WithPermissions
                component={TenantEldUsageByEventsByDays}
                basePath={basePath}
                resource={resourceNames.MASTER_TENANT_REGISTRATIONS}
                id={id}
                {...routeProps}
                {...listOnlyComponentProps}
                hasShow
              />
            </ResourceContextProvider>
          </RequireActionPermission>
        );
      }}
    />,
    <Route exact path="/reports/dvir-history" component={DvirHistoryReport} />,
    <Route
      exact
      path="/reports/trip-report-detail"
      component={TripReportDetail}
    />,
    <Route exact path="/reports/trip-detail" component={TripDetail} />,
    <Route
      exact
      path="/reports/ifta-mileage"
      component={IftaMileageReportBasic}
    />,
    <Route exact path="/reports" component={Reports} />,
    <Route exact path="/data-import-export" component={DataImportExport} />,
    <Route
      exact
      path="/data-import-export/:category"
      component={DataTransferCategoryPage}
    />,
    <Route
      exact
      path={`/${resourceNames.HOS_DRIVER_LOGS}/:id`}
      render={(routeProps) => (
        <ResourceContextProvider value={resourceNames.HOS_DRIVER_LOGS}>
          <WithPermissions
            component={DriverLogsList}
            basePath={`/${resourceNames.HOS_DRIVER_LOGS}`}
            resource={resourceNames.HOS_DRIVER_LOGS}
            {...routeProps}
            {...listOnlyComponentProps}
          />
        </ResourceContextProvider>
      )}
    />,
    <Route
      path={`/${resourceNames.HOS_DRIVER_LOG_VIEW}/:driverId/:id`}
      render={(routeProps) => (
        <ResourceContextProvider value={resourceNames.HOS_DRIVER_LOG_VIEW}>
          <WithPermissions
            component={DriverLogView}
            basePath={`/${resourceNames.HOS_DRIVER_LOG_VIEW}`}
            resource={resourceNames.HOS_DRIVER_LOG_VIEW}
            {...routeProps}
            {...listOnlyComponentProps}
          />
        </ResourceContextProvider>
      )}
    />,
    <Route
      path={`/${resourceNames.LOCATIONS_HISTORY}`}
      render={(routeProps) => (
        <ResourceContextProvider value={resourceNames.LOCATIONS_HISTORY}>
          <WithPermissions
            component={LocationsHistoryView}
            basePath={`/${resourceNames.LOCATIONS_HISTORY}`}
            resource={resourceNames.LOCATIONS_HISTORY}
            {...routeProps}
            {...listOnlyComponentProps}
          />
        </ResourceContextProvider>
      )}
    />,
    <Route
      path={`/${resourceNames.ASSETS_VEHICLE_MAINTENANCE}/:id/create`}
      render={(routeProps) => {
        let basePath = `/${resourceNames.ASSETS_VEHICLE_MAINTENANCE}`;
        if (routeProps.match?.params.id) {
          basePath = `${basePath}/${routeProps.match?.params?.id}`;
        }

        return (
          <ResourceContextProvider
            value={resourceNames.ASSETS_VEHICLE_MAINTENANCE}
          >
            <WithPermissions
              component={VehicleMaintenanceCreate}
              basePath={basePath}
              resource={resourceNames.ASSETS_VEHICLE_MAINTENANCE}
              {...routeProps}
              {...listOnlyComponentProps}
              hasList
              hasCreate
              hasEdit
            />
          </ResourceContextProvider>
        );
      }}
    />,
    <Route
      path={`/${resourceNames.ASSETS_VEHICLE_MAINTENANCE}/:id/:maintenanceId`}
      render={(routeProps) => {
        let basePath = `/${resourceNames.ASSETS_VEHICLE_MAINTENANCE}`;
        if (routeProps.match?.params.id) {
          basePath = `${basePath}/${routeProps.match?.params?.id}`;
        }

        return (
          <ResourceContextProvider
            value={resourceNames.ASSETS_VEHICLE_MAINTENANCE}
          >
            <WithPermissions
              component={VehicleMaintenanceEdit}
              basePath={basePath}
              resource={resourceNames.ASSETS_VEHICLE_MAINTENANCE}
              id={decodeURIComponent(routeProps.match.params.maintenanceId)}
              {...routeProps}
              {...listOnlyComponentProps}
              hasList
              hasCreate
              hasEdit
            />
          </ResourceContextProvider>
        );
      }}
    />,
    <Route
      path={`/${resourceNames.ASSETS_VEHICLE_MAINTENANCE}/:id`}
      render={(routeProps) => {
        let basePath = `/${resourceNames.ASSETS_VEHICLE_MAINTENANCE}`;
        if (routeProps.match?.params.id) {
          basePath = `${basePath}/${routeProps.match?.params?.id}`;
        }

        return (
          <ResourceContextProvider
            value={resourceNames.ASSETS_VEHICLE_MAINTENANCE}
          >
            <WithPermissions
              component={VehicleMaintenanceList}
              basePath={basePath}
              resource={resourceNames.ASSETS_VEHICLE_MAINTENANCE}
              {...routeProps}
              {...listOnlyComponentProps}
              hasList
              hasCreate
              hasEdit
            />
          </ResourceContextProvider>
        );
      }}
    />,
    <Route
      path={`/${resourceNames.ASSETS_MAINTENANCE_DASHBOARD}/:id`}
      render={(routeProps) => {
        let basePath = `/${resourceNames.ASSETS_VEHICLE_MAINTENANCE}`;
        let props: { vehicleId?: number } = {};
        if (routeProps.match?.params.id) {
          basePath = `${basePath}/${routeProps.match?.params?.id}`;
          props.vehicleId = Number(routeProps.match?.params?.id);
        }

        return (
          <ResourceContextProvider
            value={resourceNames.ASSETS_MAINTENANCE_DASHBOARD}
          >
            <WithPermissions
              component={VehicleMaintenanceDashboard}
              basePath={basePath}
              resource={resourceNames.ASSETS_MAINTENANCE_DASHBOARD}
              {...routeProps}
              {...listOnlyComponentProps}
              hasList
              {...props}
            />
          </ResourceContextProvider>
        );
      }}
    />,
    <Route
      path={`/${resourceNames.ASSETS_DVIR_HISTORY}/:id/:dvirId`}
      render={(routeProps) => {
        let basePath = `/${resourceNames.ASSETS_DVIR_HISTORY}`;
        if (routeProps.match?.params.id) {
          basePath = `${basePath}/${routeProps.match?.params?.id}`;
        }

        return (
          <ResourceContextProvider
            value={resourceNames.ASSETS_DVIR_VEHICLE_DEFECTS}
          >
            <WithPermissions
              component={VehicleDvirView}
              basePath={basePath}
              resource={resourceNames.ASSETS_DVIR_VEHICLE_DEFECTS}
              {...routeProps}
              {...listOnlyComponentProps}
              hasList
            />
          </ResourceContextProvider>
        );
      }}
    />,
    <Route
      path={`/${resourceNames.ASSETS_DVIR_HISTORY}/:id`}
      render={(routeProps) => {
        let basePath = `/${resourceNames.ASSETS_DVIR_HISTORY}`;
        if (routeProps.match?.params.id) {
          basePath = `${basePath}/${routeProps.match?.params?.id}`;
        }

        return (
          <ResourceContextProvider
            value={resourceNames.ASSETS_DVIR_VEHICLE_HISTORY}
          >
            <WithPermissions
              component={VehicleDvirHistoryList}
              basePath={basePath}
              resource={resourceNames.ASSETS_DVIR_VEHICLE_HISTORY}
              {...routeProps}
              {...listOnlyComponentProps}
              hasList
            />
          </ResourceContextProvider>
        );
      }}
    />,
    <Route
      path={`/${resourceNames.LOCATIONS_LIVETRACK}/:id?/:tenantId?`}
      render={(routeProps) => (
        <LocationLiveTrack {...routeProps.match?.params} />
      )}
    />,
    <Route
      path={`/${resourceNames.MASTER_ELDS}/show-messages/:id`}
      render={(routeProps) => {
        let basePath = `/${resourceNames.MASTER_ELDS}`;

        return (
          <ResourceContextProvider value={resourceNames.ADMIN_ELD_MESSAGES}>
            <WithPermissions
              component={EldMessagesList}
              basePath={basePath}
              resource={resourceNames.ADMIN_ELD_MESSAGES}
              {...routeProps}
              {...listOnlyComponentProps}
              hasList
            />
          </ResourceContextProvider>
        );
      }}
    />,
    <Route
      path={`/${resourceNames.MASTER_ELDS}/create-multiple`}
      render={(routeProps) => {
        let basePath = `/${resourceNames.MASTER_ELDS}`;

        return (
          <ResourceContextProvider value={resourceNames.MASTER_ELDS}>
            <WithPermissions
              component={EldMultipleCreate}
              basePath={basePath}
              resource={resourceNames.MASTER_ELDS}
              {...routeProps}
              hasList
              hasCreate
            />
          </ResourceContextProvider>
        );
      }}
    />,
    <Route
      exact
      path={`/${resourceNames.SAFETY_DASHBOARD}/:id`}
      render={(routeProps) => {
        let basePath = `/${resourceNames.SAFETY_DASHBOARD}`;
        let props: { driverId?: number } = {};
        if (routeProps.match?.params.id) {
          basePath = `${basePath}/${routeProps.match?.params?.id}`;
          props.driverId = Number(routeProps.match?.params?.id);
        }

        return (
          <ResourceContextProvider value={resourceNames.SAFETY_DASHBOARD}>
            <WithPermissions
              component={DriverSafetyDashboard}
              basePath={basePath}
              resource={resourceNames.SAFETY_DASHBOARD}
              {...routeProps}
              {...listOnlyComponentProps}
              hasList
              {...props}
            />
          </ResourceContextProvider>
        );
      }}
    />,
    <Route
      exact
      path={`/${resourceNames.LOCATIONS_STATE_TRIPS}/:type/:id`}
      render={(routeProps) => {
        let basePath = `/${resourceNames.LOCATIONS_STATE_TRIPS}`;
        let props: { id?: number; type?: string } = {};
        if (routeProps.match?.params.id && routeProps.match?.params.type) {
          basePath = `${basePath}/${routeProps.match?.params?.id}`;
          props.id = Number(routeProps.match?.params?.id);
          props.type = routeProps.match?.params.type;
        }

        return (
          <ResourceContextProvider value={resourceNames.SAFETY_DASHBOARD}>
            <WithPermissions
              component={StateTripsSingle}
              basePath={basePath}
              resource={resourceNames.LOCATIONS_STATE_TRIPS}
              {...routeProps}
              {...listOnlyComponentProps}
              hasList
              {...props}
            />
          </ResourceContextProvider>
        );
      }}
    />,
    <Route
      path={`/${resourceNames.ADMIN_API_CLIENTS}/view/:id`}
      render={(routeProps) => (
        <ResourceContextProvider value={resourceNames.ADMIN_API_CLIENTS}>
          <WithPermissions
            component={ViewRedirectApiClient}
            basePath={`/${resourceNames.ADMIN_API_CLIENTS}`}
            resource={resourceNames.ADMIN_API_CLIENTS}
            {...routeProps}
            {...listOnlyComponentProps}
          />
        </ResourceContextProvider>
      )}
    />,
  ];
};
